/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/EngageSection.css";
import lightbulbIcon from "../assets/icon-lightbulb.png";
import infoIcon from "../assets/icon-info.png";
import arrowIcon from "../assets/arrow.png";

const EngageSection = () => {
  const navigate = useNavigate();

  return (
    <section className="engage-section">
      <div className="engage-inner">
        <h2 className="section-title">Train</h2>
        <div className="engage-card-group">
          {/* Card 1 */}
          <div className="engage-card" onClick={() => navigate("/challenge")}>
            <img src={lightbulbIcon} alt="Test Skills" className="card-icon" />
            <h3 className="card-title">
              Test your skills spotting misinformation
            </h3>
            <p className="card-body">
              Interactive challenges to sharpen your fact-checking abilities
            </p>
            <a className="card-link">
              Take Challenge <img src={arrowIcon} alt="arrow" />
            </a>
          </div>

          {/* Card 2 */}
          <div
            className="engage-card"
            onClick={() => navigate("/backgroundinfo")}
          >
            <img src={infoIcon} alt="Government" className="card-icon" />
            <h3 className="card-title">
              Understand how government and policies work
            </h3>
            <p className="card-body">
              Clear explanations of complex political processes
            </p>
            <a className="card-link">
              Learn More <img src={arrowIcon} alt="arrow" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngageSection;
